<template>
    <footer class="footer">
        <div class="container">
            <div class="content has-text-centered">
                <p class="social">
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
  export default {

    data () {
      return {}
    },
    mounted () {

      let today = new Date()
      let nowHours = today.getHours()
      let now = today.getTime()

      let night
      if(nowHours > 8 && nowHours < 22){
        night = today.setHours(22, 0, 0, 0)
      } else{
        night = today.setHours(8, 0, 0, 0)
      }

      let delay = night - now


      setTimeout(function () {
        let app = document.getElementById('app')
        app.classList.add("dark-theme")
      }, delay)

      //
      // window.addEventListener('resize', function () {
      //   document.getElementById('reloadContent').click()
      // })
    },
  }

</script>





// WEBPACK FOOTER //
// resources/assets/js/components/layout/FooterBar.vue